import React from "react"

function IconHexagonsAttached({ color = "currentColor", color2, fontSize, height, ...props }) {
  return (
    <svg
      fill={color}
      fuze-icon="hexagons-attached"
      viewBox="0 0 24 24"
      style={{ height: height || fontSize }}
      originalclass="fz-icon fz-icon-hexagons-attached"
      {...props}
    >
      <path
        d="M10.948 2.68a2.115 2.115 0 0 1 1.94-.085l.166.086 2.91 1.675a2.1 2.1 0 0 1 1.047 1.65l.007.171v4.134l3.31 1.905c.602.347.99.965 1.047 1.648l.007.172v3.35c0 .693-.342 1.338-.908 1.73l-.146.092-2.91 1.674a2.108 2.108 0 0 1-1.94.086l-.166-.086L12 18.978l-3.31 1.904a2.109 2.109 0 0 1-1.94.086l-.166-.086-2.91-1.674a2.102 2.102 0 0 1-1.049-1.649l-.007-.172v-3.35a2.1 2.1 0 0 1 .91-1.729l.146-.092 3.308-1.905V6.177c0-.694.343-1.34.91-1.73l.147-.091 2.91-1.676zm-3.312 8.766-3.311 1.906a.791.791 0 0 0-.389.566l-.009.12v3.349a.79.79 0 0 0 .3.618l.1.068 2.91 1.675c.213.122.466.14.69.052l.11-.053 3.308-1.903V13.58l-3.709-2.134zm8.728 0-3.71 2.133v4.265l3.311 1.904a.797.797 0 0 0 .575.087l.115-.035.11-.053 2.91-1.674a.796.796 0 0 0 .389-.567l.009-.12v-3.35a.793.793 0 0 0-.298-.618l-.1-.068-3.311-1.904zm-3.962-7.63a.807.807 0 0 0-.692-.053l-.11.052-2.91 1.676a.79.79 0 0 0-.39.567l-.01.12v3.805L12 12.117l3.71-2.134V6.177a.79.79 0 0 0-.212-.538l-.087-.08-.1-.068-2.909-1.675z"
        fill={color}
        fillRule="evenodd"
        style={{ height: height || fontSize }}
        originalclass="__primary"
      />
    </svg>
  )
}

export default IconHexagonsAttached
